import React from 'react'
import { useSelector } from 'react-redux'
import { Route, Redirect } from 'react-router-dom'
import paths from './paths'

const PublicRoute = props => {
    const user = useSelector(state => state.AccountReducer.user)

    const { component: Component, path, exact } = props
    return (
        <Route
            path={path}
            exact={exact}
            render={props =>
                !user ? <Component {...props} /> : <Redirect to={paths.home} />
            }
        />
    )
}

export default PublicRoute
